import { IdeasTab } from "@/entities/ideas-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsIdeasRouteV2: RouteProps = {
  path: appRouterPaths.contacts.ideas,
  element: <IdeasTab />,
};
